/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$('.product__main-slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  arrows: false,
  dots: false,
  asNavFor: '.product__thumb-slider'
});
$('.product__thumb-slider').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.product__main-slider',
  dots: false,
  arrows: false,
  infinite: true,
  focusOnSelect: true
});
$(document).on('click','.flex-footer__item--menu .site-footer__newsletter-label',function(){
  if($(window).width() < 750){
    $(this).parents('.flex-footer__item--menu').siblings('.flex-footer__item--menu').find('.site-footer__linklist').slideUp();
    $(this).next('.site-footer__linklist').slideToggle();
  }
});


$(function(){
  
  $(document).on("change", ".collection_variants", function(){
    /*$(".collection_variants").change(function(){});*/
    var id = $(this).val();
    var pid = $(this).attr("data-pid");
    var price = $("."+id).val();
    var compPrice = $("."+id).attr("date-comprice");
    $('.product-price-'+pid).html(price);
    $('.product-comprice-'+pid).html(compPrice);
  });
  
   
});